import { forwardRef } from "react";
import { gql } from "utils/urql";
import ArticleInlineImageFigure from "./ArticleInlineImageFigure";
import {
  ArticleOverflowInlineImageFragment,
  ArticleInlineImageAlignment,
} from "types/api";

const ArticleOverflowInlineImage = forwardRef<
  HTMLElement,
  ArticleOverflowInlineImageFragment
>(function ArticleOverflowInlineImage(
  { url, srcSet, width, height, crop, ...props },
  ref
) {
  const sizes = crop
    ? [
        "(min-width: 982px) 928px",
        "(min-width: 786px) calc(100vw - 54px)",
        "100vw",
      ].join(", ")
    : undefined;
  if (crop) {
    url = crop.url;
    width = crop.width;
    height = crop.height;
    srcSet = crop.srcSet;
  }
  return (
    <ArticleInlineImageFigure
      url={url}
      ref={ref}
      srcSet={srcSet}
      width={width}
      height={height}
      sizes={sizes}
      alignment={ArticleInlineImageAlignment.Overflow}
      {...props}
    />
  );
});

ArticleOverflowInlineImage.fragment = gql`
  ${ArticleInlineImageFigure.fragment}

  fragment articleOverflowInlineImage on ArticleOverflowInlineImage {
    ...articleInlineImageFigure
    crop(
      width: 928
      sizes: ["640w", "750w", "850w", "928w", "1536w", "1856w"]
    ) {
      url
      width
      height
      srcSet
    }
    clickthroughUrl
  }
`;

export default ArticleOverflowInlineImage;
